import TripColumnsMultiSelect from './TripColumnsMultiSelect';

export default TripColumnsMultiSelect;
